<template>
  <div class="singleDisbursementModal">
    <el-dialog :visible.sync="dialogVisible" class="diglog-card" :close-on-click-modal="false" :title="dialogTitle" width="910px" @close="onClose">
      <div class="header-line" />
      <div class="section-title">
        {{ $t('merchantAccount.beneficiary_account_information') }}
      </div>
      <div class="form-container">
        <el-form ref="form" :model="form" status-icon label-position="top">
          <el-row>
            <el-col :span="11">
              <el-form-item
                :label="$t('merchantAccount.recipient_channel')"
                prop="disbursement_channel"
                :rules="[
                  { required: true, message: 'Receiving channel cannot be empty', trigger: 'blur'}
                ]"
              >
                <el-select v-model="form.disbursement_channel" :disabled="disabled" filterable class="select-item" clearable @change="disbursementChannelChange">
                  <el-option
                    v-for="(item,index) in bankList"
                    :key="index"
                    :label="item.name_with_full_bank"
                    :value="item.bank_code"
                  />
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="11" :offset="2">
              <el-form-item
                :label="$t('merchantAccount.account_holder_name')"
                prop="disbursement_name"
                :rules="[
                  { required: true, message: 'Account Holder Name cannot be empty', trigger: 'blur'},
                  { validator: checkWhitespace, trigger: 'blur'},
                  { validator: checkName, trigger: 'blur'},
                ]"
              >
                <el-input v-model="form.disbursement_name" :disabled="disabled" placeholder="Enter Account Holder Name" class="search-frame" maxlength="100" autocomplete="off" clearable show-word-limit />
              </el-form-item>
            </el-col>

          </el-row>

          <el-row v-if="showBeneficiaryType">
            <el-col :span="11" :offset="2">
              <el-form-item
                :label="$t('merchantAccount.recipient_account_type')"
                prop="beneficiary_type"
                :rules="[
                  { required: true, message: 'Account Type cannot be empty', trigger: 'blur'}
                ]"
              >
                <el-select v-model="form.beneficiary_type" :disabled="disabled" filterable class="select-item" clearable placeholder="Select Account Type">
                  <el-option
                    v-for="(item, index) in beneficiaryTypeOptions"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="11">

              <el-form-item
                class="mt-12"
                :label="$t('merchantAccount.account_no')"
                prop="disbursement_number"
                :rules="[
                  { required: true, message: 'Account No. cannot be empty', trigger: ['blur','change']},
                  { validator: checkoutAccountNo, trigger: ['blur','change']}
                ]"
              >
                <el-input v-model="form.disbursement_number" :disabled="disabled" placeholder="Enter Account No." class="search-frame" maxlength="50" autocomplete="off" clearable show-word-limit />
              </el-form-item>
            </el-col>

            <el-col :span="11" :offset="2">
              <el-form-item
                class="mt-12"
                :label="$t('merchantAccount.short_name')"
                prop="disbursement_short_name"
                :rules="[
                  { required: true, message: 'Short name cannot be empty', trigger: ['blur','change']},
                  { validator: checkWhitespace, trigger: 'blur'}
                ]"
              >
                <el-input v-model="form.disbursement_short_name" :disabled="disabled && !isEdit" placeholder="Fill in the short name" class="search-frame" maxlength="64" autocomplete="off" clearable show-word-limit />

                <el-button v-if="disabled && !isEdit" class="ml-20 confirm-btn-bg" size="small" @click="onClickEditShort">{{ $t('components.edit') }}</el-button>
                <el-button v-if="isEdit" class="ml-20 confirm-btn-bg" size="small" @click="onClickSubmit">{{ $t('components.confirm') }}</el-button>
                <el-button v-if="isEdit" class="ml-20 cancel-btn-bg" size="small" @click="cancelShortName">{{ $t('components.cancel') }}</el-button>
              </el-form-item>
            </el-col>

          </el-row>

          <div class="section-title">
            {{ $t('merchantAccount.basic_company_information_of_beneficiary') }}
          </div>

          <el-row>
            <el-col :span="11">

              <el-form-item
                class="mt-12"
                :label="$t('merchantAccount.full_legal_entity_name_of_beneficiary')"
                prop="company_information_full_name"
                :rules="[
                  { required: true, message: 'Full Legal Entity Name Of Beneficiary cannot be empty', trigger: ['blur','change']},
                  { validator: checkName, trigger: ['blur','change']},
                  { validator: checkWhitespace, trigger: 'blur'},
                ]"
              >
                <el-input v-model="form.company_information_full_name" :disabled="disabled" placeholder="Enter Full Legal Entity Name Of Beneficiary" class="search-frame" maxlength="50" autocomplete="off" clearable show-word-limit />
              </el-form-item>
            </el-col>

            <el-col :span="11" :offset="2">
              <el-form-item
                :label="$t('merchantAccount.registered_country')"
                prop="company_information_registered_country"
                :rules="[
                  { required: true, message: 'Registered Country cannot be empty', trigger: 'blur'},
                ]"
              >
                <el-select v-model="form.company_information_registered_country" :disabled="disabled" filterable placeholder="Enter Registered Country/Region" class="select-item" clearable>
                  <el-option
                    v-for="(item,index) in onlineCountryList"
                    :key="index"
                    :label="(language === 'zh' ? item.cn_name : item.en_name)"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
            </el-col>

          </el-row>

          <el-row>
            <el-col :span="11">

              <el-form-item
                class="mt-12"
                :label="$t('merchantAccount.registered_address')"
                prop="company_information_registered_address"
                :rules="[
                  { required: true, message: 'Registered Address cannot be empty', trigger: ['blur','change']},
                  { validator: checkWhitespace, trigger: 'blur'},
                ]"
              >
                <el-input v-model="form.company_information_registered_address" :disabled="disabled" placeholder="Enter Registered Address" class="search-frame" maxlength="50" autocomplete="off" clearable show-word-limit />
              </el-form-item>
            </el-col>

          </el-row>

          <div class="section-title">
            {{ $t('merchantAccount.authorized_representative') }}
          </div>

          <el-row>
            <el-col :span="11">

              <el-form-item
                class="mt-12"
                :label="$t('merchantAccount.full_name')"
                prop="authorized_representative_full_name"
                :rules="[
                  { required: true, message: 'Full Name cannot be empty', trigger: ['blur','change']},
                  { validator: checkName, trigger: ['blur','change']},
                  { validator: checkWhitespace, trigger: 'blur'}
                ]"
              >
                <el-input v-model="form.authorized_representative_full_name" :disabled="disabled" placeholder="Enter Full Name" class="search-frame" maxlength="50" autocomplete="off" clearable show-word-limit />
              </el-form-item>
            </el-col>

            <el-col :span="11" :offset="2">
              <el-form-item
                class="mt-12"
                :label="$t('merchantAccount.position')"
                prop="authorized_representative_position"
                :rules="[
                  { required: true, message: 'Position cannot be empty', trigger: ['blur','change']},
                  { validator: checkWhitespace, trigger: 'blur'}
                ]"
              >
                <el-input v-model="form.authorized_representative_position" :disabled="disabled" placeholder="Enter Position" class="search-frame" maxlength="64" autocomplete="off" clearable show-word-limit />
              </el-form-item>
            </el-col>

          </el-row>

          <el-row>
            <el-col :span="11">
              <UploadFileDrawingBoard v-if="dialogVisible" ref="UploadFileDrawingBoard" class="mt-20" :disabled="disabled" @uploadFileSuccess="uploadFileSuccess" />
            </el-col>

          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item
                class="mt-20 remarkLabel"
                :label="$t('data.remark')"
                prop="remark"
              >
                <span>
                  {{ $t('tips.large_value_beneficiary_remark_tip') }}
                </span>
                <el-input
                  v-model="form.remark"
                  placeholder="Enter your message here"
                  type="textarea"
                  autocomplete="off"
                  maxlength="256"
                  :disabled="disabled"
                  show-word-limit
                />
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
      </div>

      <div v-if="!disabled" slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">{{ $t('components.cancel') }}</el-button> -->
        <el-button type="info" :disabled="submiting" class="btn-submit" @click="onClickSubmitBtn()">{{ $t('components.submit') }}</el-button>
      </div>
    </el-dialog>
    <ContractDescriptionModal ref="ContractDescriptionModal" />
  </div>
</template>

<script>
import {
  createLargeValueBeneficiary,
  editLargeValueBeneficiary,
  queryLargeValueBeneficiaryDetail,
  updateBeneficiaryShortName
} from '@/api/online-transaction/online-transaction.js'
import { fetchDisbursementAllCodeList, fetchOnlineCountryList, getAllCountry } from '@/api/components/components.js'
import { beneficiaryTypeOptionsForVN } from '@/utils/maps'
import UploadFileDrawingBoard from '@/views/components/Upload/UploadFileDrawingBoard.vue'
export default {
  name: 'Single_Disbursement_Modal',
  components: {
    UploadFileDrawingBoard,
    ContractDescriptionModal: () => import('./ContractDescriptionModal.vue')
  },
  data() {
    this.BANK = 1
    this.EWALLET = 2
    this.checkWhitespace = (rule, value, callback) => {
      if (value.trim() !== value) {
        return callback(new Error('Please make sure there are no spaces at the beginning or end of your input.'))
      }
      callback()
    }
    this.checkName = (rule, value, callback) => {
      if (!/^[a-zA-Z\s.'-]{1,100}$/.test(value)) {
        return callback(new Error('Please enter the correct name'))
      }
      callback()
    }
    this.checkoutAccountNo = (rule, value, callback) => {
      const bankItem = this.bankList.find(item => item.bank_code === this.form.disbursement_channel) || {}

      if (/\s/g.test(value)) {
        return callback(new Error('The input value cannot contain spaces'))
      }
      if (value !== '0' && !Number(value)) {
        return callback(new Error('Only can input number'))
      }

      if (bankItem.bank_type === this.EWALLET) {
        if (this.$store.getters.curCountry.country_code === 'TH' && !/^0([689]\d{8})$/.test(value)) {
          return callback(new Error('Please enter the 10 numbers starting with 0, followed by 6, 8, or 9.'))
        }
        if (!/(09)\d{9}$/.test(value)) {
          return callback(new Error(' Pls input the correct Recipient account number and start with 09'))
        }
      }
      if (value.trim() !== value) {
        return callback(new Error('Please make sure there are no spaces at the beginning or end of your input.'))
      }
      if (value.length && value.length < 5) {
        return callback(new Error('Please input between 5 to 50 characters.'))
      }
      callback()
    }
    return {
      bankList: [],
      form: {
        contract_attachment_list: [],
        disbursement_number: null,
        authorized_representative_signature_file_name: null,
        beneficiary_type: null
      },
      filePath: '',
      fileName: '',
      absolutePath: null,
      dialogVisible: false, // 控制弹框显示隐藏
      submiting: false,
      initData: {},
      signature: null,
      disabled: false,
      onlineCountryList: [],
      isEdit: false,
      old_disbursement_short_name: ''
    }
  },
  computed: {
    isImg() {
      return function(value) {
        return /\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/.test(value)
      }
    },
    dialogTitle() {
      if (this.disabled) {
        return this.$t('components.detail')
      } else if (this.initData.id) {
        return this.$t('components.edit')
      } else {
        return this.$t('components.create')
      }
    },
    isView() {
      return !!(this.$route.query.isView)
    },
    language() {
      return this.$store.getters.language
    },
    showBeneficiaryType() {
      return this.$store.getters.curCountry.country_code === 'VN'
    },
    beneficiaryTypeOptions() {
      return beneficiaryTypeOptionsForVN()
    }
  },
  created() {
    this.getAllBank()
    this.getOnlineCountry()
  },
  methods: {
    getOnlineCountry() {
      getAllCountry().then(res => {
        const list = res.data || []
        this.onlineCountryList = list.filter(item => !['CN'].includes(item.code))
      })
    },
    showModal(row, disabled = false) {
      this.dialogVisible = true
      if (row) {
        this.getDetail(row)
        this.initData = row
      }
      this.disabled = disabled
    },
    showContractModal() {
      this.$refs.ContractDescriptionModal.showModal()
    },
    addOssUrlModal(row) {
      this.$refs.UploadFileDrawingBoard.addOssUrl(row)
    },
    getDetail(row) {
      queryLargeValueBeneficiaryDetail({ id: row.id }).then(res => {
        const { contract_attachment_list = [], ...other } = res.data
        const list = contract_attachment_list.map(item => {
          return { fileName: item.file_name,
            absolutePath: item.file_oss_url, file_path: item.file_path }
        })
        this.form = {
          contract_attachment_list: list,
          ...other
        }
        this.addOssUrlModal(this.form.authorized_representative_signature_file_oss_url)
        this.clearValidate('form')
      })
    },
    disbursementChannelChange() {
      if (this.form.disbursement_channel) {
        this.$nextTick(function() {
          this.$refs['form'].clearValidate(['disbursement_channel'])
        })
      }
      this.form.disbursement_number = null
      this.$nextTick(function() {
        this.$refs['form'].clearValidate(['disbursement_number'])
      })
    },
    contractAttachmentListChange() {
      if (this.form.contract_attachment_list) {
        this.$nextTick(function() {
          this.$refs['form'].clearValidate(['contract_attachment_list'])
        })
      }
    },
    clearValidate(formName) {
      this.$nextTick(function() {
        this.$refs[formName].clearValidate()
      })
    },
    templateFileSuccess(data) {
      this.form.contract_attachment_list.push(data)
    },
    onClickRemoveBtn(item) {
      this.form.contract_attachment_list = this.form.contract_attachment_list.filter(i => i.absolutePath !== item.absolutePath)
    },

    getAllBank() {
      fetchDisbursementAllCodeList().then(res => {
        const list = res.data
        list.map(item => {
          item.name_with_full_bank = item.bank_code
          if (item.bank_type === this.BANK) {
            item.name_with_full_bank = item.bank_code + ' - ' + item.full_name
          }
          return item
        })
        this.bankList = list
      })
    },
    onClickSubmitBtn() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t('tips.whether_to_submit'), this.$t('components.tips'), {
            confirmButtonText: this.$t('components.submit'),
            cancelButtonText: this.$t('components.cancel'),
            type: 'warning'
          }).then(() => {
            if (!this.form.authorized_representative_signature_file_name) {
              this.$message.warning('Please sign by hand!')
              return
            }
            const { ...otherForm } = this.form
            const params = { ...otherForm }
            this.submiting = true
            if (params.disbursement_number) {
              params.disbursement_number = params.disbursement_number.trim()
            }
            if (params.disbursement_name) {
              params.disbursement_name = params.disbursement_name.trim()
            }
            let requestEvent = createLargeValueBeneficiary
            if (this.initData.id) {
              params.id = this.initData.id
              requestEvent = editLargeValueBeneficiary
            }
            requestEvent(params).then(res => {
              if (res.code === 10000) {
                this.dialogVisible = false
                this.$emit('updateList')
              }
            }).finally(() => {
              this.submiting = false
            })
          })
        }
      })
    },
    cancelShortName() {
      this.isEdit = false
      this.clearValidate('form')
      this.form.disbursement_short_name = this.old_disbursement_short_name
    },
    onClickSubmit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.submiting = true
          const params = {
            id: this.form.id,
            ...this.form
          }
          updateBeneficiaryShortName(params).then(res => {
            if (res.code === 10000) {
              this.isEdit = false
              this.$message.success('Success')
              this.$emit('updateList')
            }
          }).finally(() => {
            this.dialogTableVisible = false
            this.submiting = false
          })
        }
      })
    },
    onClickEditShort() {
      this.isEdit = true
      this.old_disbursement_short_name = this.form.disbursement_short_name
    },
    onClose() {
      this.initData = {}
      this.form = {
        disbursement_number: null,
        beneficiary_type: null
      }
      this.clearValidate('form')
      this.isEdit = false
    },
    uploadFileSuccess(data) {
      this.form.authorized_representative_signature_file_name = data.fileName
      this.form.authorized_representative_signature_file_path = data.filePath
    }
  }

}
</script>
<style>
.remarkLabel .el-form-item__label{
  line-height: 24px;
}
</style>
<style scoped>
.form-container /deep/ .el-input__inner{
  padding-right: 80px;
}
.select-item{
  width:100%;
}
.tip{
  font-size: 14px;
  font-weight: 400;
  color: #303133;
}
.dialog-footer{
  margin-top: -16px;
  text-align: center;
}
.btn-submit{
  width: 500px;
  height: 40px;
  border-radius: 4px;
}
.file-container{
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.content-img{
  cursor: pointer;
  height: 100px;
  max-width: 300px;
}
.content-file{
  color:#3855F1;
  text-decoration: underline;
  cursor: pointer;
}

.reply-content-img{
  margin-bottom: 10px;
}
.reply-content-file{
  display: inline-block;
  width: 200px;
  margin-bottom: 10px;
  cursor: pointer;
  text-decoration: underline;
  vertical-align: middle;
  color: #3855F1;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
.check-class{
  color: #3855F1;
  margin-top: -2px;
  margin-left: -3px
}
.mt-12{
  margin-top: 12px;
}
.search-frame{
}
.signature-box{
  /*display: flex;*/
  /*align-items: flex-end;*/
  /*canvas {*/
  /*margin-bottom: 5px;*/
  /*}*/
  .clear-btn {
    height: 30px;
  }
}
.form-label {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 6px;
  color: #1D3A71;
}
.mt-20 {
  margin-top: 20px;
}
</style>

